'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.senderTypeToAgentType = undefined;

var _agentTypes = require('../../pubnub-message/constants/agentTypes');

var _senderTypes = require('../../pubnub-message/constants/senderTypes');

var senderTypeToAgentType = exports.senderTypeToAgentType = function senderTypeToAgentType(senderType) {
  return senderType === _senderTypes.BOT ? _agentTypes.BOT : _agentTypes.HUMAN;
};